import type { CustomIconProps } from '../CustomIcon';

export const PushAcceptedIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='m23 2-7 20-4-9-9-4 20-7Z' fill='#BDDEE1' />
      <path
        d='M23 2 12 13'
        stroke='#006D86'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx={7} cy={17} r={6} fill='#60AE24' stroke='#fff' />
      <path d='M4 16.5 6.308 19 10 15' stroke='#fff' strokeWidth={1.5} />
    </svg>
  );
};
